import {
  MarketingCampaign,
  MarketingCampaignStep,
  Practice,
} from '@principle-theorem/principle-core';
import {
  IPractice,
  MarketingCampaignType,
  TemplateScope,
  TimingDirection,
  TimingUnit,
} from '@principle-theorem/principle-core/interfaces';
import {
  activePatientsCampaignReportTemplate,
  FactTables,
} from '@principle-theorem/reporting';
import {
  ALL_REGIONS,
  asReffable,
  CustomRecurrenceFrequency,
  DocumentReference,
} from '@principle-theorem/shared';
import { IMarketingCampaignTemplate } from './marketing-campaign-template';
import { MarketingCampaignTemplateFactory } from './marketing-campaign-template-factory';

export function getOnceOffSmsCampaignTemplate(
  practiceRef: DocumentReference<IPractice>
): IMarketingCampaignTemplate {
  return {
    name: 'Once off SMS',
    description: 'Send a one-time SMS message or announcement.',
    regions: ALL_REGIONS,
    campaign: MarketingCampaign.init({
      brandRef: Practice.brandRef(asReffable(practiceRef)),
      practiceRef,
      name: 'Once off SMS',
      type: MarketingCampaignType.GeneralNotice,
      scope: TemplateScope.Patient,
      entryResetRules: {
        multipleEntry: false,
        maxEntryCount: undefined,
        frequencyCount: 1,
        frequencyType: CustomRecurrenceFrequency.Daily,
      },
    }),
    report: activePatientsCampaignReportTemplate(
      FactTables.patientEvent.latestEvent
    ),
    steps: [
      MarketingCampaignStep.init({
        name: 'Once off SMS',
        config: MarketingCampaignTemplateFactory.automationSMS(
          'Your SMS content here.',
          {
            amount: 1,
            direction: TimingDirection.After,
            unit: TimingUnit.Minutes,
          }
        ),
      }),
    ],
  };
}
